import { render, staticRenderFns } from "./CategoryNavigationMenu.vue?vue&type=template&id=0a4452a0&scoped=true&"
import script from "./CategoryNavigationMenu.vue?vue&type=script&lang=js&"
export * from "./CategoryNavigationMenu.vue?vue&type=script&lang=js&"
import style0 from "./CategoryNavigationMenu.vue?vue&type=style&index=0&id=0a4452a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a4452a0",
  null
  
)

export default component.exports